<template>
  <div class="subscribe">
    <div class="heading" v-if="show_title!=false">
      <h2 class="section-title centered with-line">{{$t('title')}}</h2>
    </div>
    <div class="subscribe-form">
      <div :class="{compact: compact}">
        <div class="subscribe-input">
          <input
            type="text"
            v-validate="'required|email'"
            name="email"
            v-model="email"
            :placeholder="$t('placeholder')"
          />
        </div>
        <div class="subscribe-btn">
          <button @click="subscribe()" :class="{'spinner dark': sending}">{{$t('button')}}</button>
        </div>
      </div>
      <div class="subscribe-msg" :class="status">
        <div v-if="errors.first('email')">{{ errors.first('email') }}</div>
        <div v-else-if="msg!=''">{{msg}}</div>
      </div>
      <social></social>
    </div>
  </div>
</template>

<script>
import Api from '@/services/api-service';
import Social from '@/components/global/Social';
export default {
  components: {
    Social
  },
  props: ['show_title', 'show_description', 'compact'],
  i18n: {
    messages: {
      en: {
        title: 'Newsletter',
        placeholder: 'E-mail',
        button: 'SUBSCRIBE',
        success_msg: 'Thank yo for your subscription',
        exists_msg: 'This email already subscribed',
        error_msg: 'ERROR, Please try again',
        disabled_msg: 'This email disabled by administrator'
      },
      hy: {
        title: 'ԲԱԺԱՆՈՐԴԱԳՐՎԵԼ',
        placeholder: 'Էլ․ փոստ',
        button: 'ԲԱԺԱՆՈՐԴԱԳՐՎԵԼ',
        success_msg: 'Շնորհակալություն բաժանորդագրվելու համար',
        exists_msg: 'Այս հասցեն արդեն բաժանորդագրված է',
        error_msg: 'Տեղի է ունեցել սխալ, խնդրում ենք կրկին փորձել',
        disabled_msg: 'Այս հասցեն արգելափակված է կայքի կողմից'
      },
      ru: {
        title: 'ПОДПИСАТЬСЯ',
        placeholder: 'Почта',
        button: 'ПОДПИСАТЬСЯ',
        success_msg: 'Спасибо за подписку',
        exists_msg: 'Этот адрес уже подписан.',
        error_msg: 'Произошла ошибка, пожалуйста, попробуйте еще раз.',
        disabled_msg: 'Этот адрес заблокирован.'
      }
    }
  },
  data () {
    return {
      email: '',
      sending: false,
      msg: '',
      status: 'error'
    };
  },
  methods: {
    subscribe () {
      if (!this.sending) {
        this.msg = '';
        this.$validator.validateAll().then(result => {
          if (result) {
            this.sending = true;
            Api.post('/subscribe', {
              email: this.email
            })
              .then(response => {
                this.sending = false;
                if (response.data.status === 'success') {
                  this.status = 'success';
                  this.msg = this.$t('success_msg');
                } else if (response.data.status === 'exists') {
                  this.status = 'error';
                  this.msg = this.$t('exists_msg');
                } else if (response.data.status === 'disabled') {
                  this.status = 'error';
                  this.msg = this.$t('disabled_msg');
                }
              })
            // eslint-disable-next-line handle-callback-err
              .catch(error => {
                this.sending = false;
                this.status = 'error';
                this.msg = this.$t('error_msg');
              });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
.subscribe {
  @include mq($lg) {
    padding-left: 30px;
    padding-right: 30px;
  }
  .heading {
    text-align: center;
    margin-bottom: 60px;

    @include mq($lg) {
      margin-bottom: 50px;
    }

    h2 {
      text-transform: uppercase;
      margin-bottom: 20px;
    }
    p {
      max-width: 480px;
      margin: auto;
    }
  }
  .subscribe-form {
    width: 500px;
    max-width: 100%;
    margin: auto;
    text-align: center;

    & > div:first-child {
      &:not(.compact){
        @include mq(false, $ms) {
          display: flex;
        }
      }

      &.compact{
        .subscribe-input{
          margin-bottom: 15px;
          input{
            text-align: center;
          }
        }
        .subscribe-btn{
          button{
            width: 100%;
          }
        }
      }

      .subscribe-input {
        width: 100%;
        input {
          width: 100%;
          border: 0;
          outline: none;
          border-bottom: 1px solid #707070;
          height: 45px;
          padding-left: 10px;
          font-size: 18px;

          @include mq($ms) {
            margin-bottom: 16px;
            text-align: center;
            padding: 0;
          }

          @include placeholder {
            font-size: 18px;
          }
          &:focus {
            @include placeholder {
              color: #afacac;
            }
          }
        }
      }
      .subscribe-btn {
        text-align: center;
        @include mq($ms) {
          margin-top: 15px;
        }
        button {
          height: 45px;
          background: none;
          border: 0;
          border-bottom: 1px solid #707070;
          cursor: pointer;
          font-size: 18px;
          outline: none;

          @include mq($ms) {
            margin-bottom: 16px;
            width: 100%;
          }
        }
      }
    }

    .subscribe-msg {
      margin-top: 15px;
      font-size: 14px;
      padding-left: 10px;
      &.success {
        color: green;
      }
      &.error {
        color: red;
      }
    }

    .social-links{
      margin-top: 30px;
    }
  }
}
</style>
